import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SingleSeriesChartViewDataItem } from '@app/components/charts/charts.models';
import { ChartColorProvider, DashboardColorTypes } from '@app/helpers/chartColorProvider';
import { localeNumberFormat } from '@app/helpers/number-formater';
import { isNullish } from '@commonHelpers/math-utils';
import { ChartMiniDonutComponent } from '../../../components/charts/chart-mini-donut/chart-mini-donut.component';

@Component({
    selector: 'app-mini-donut-percentage',
    templateUrl: './mini-donut-percentage.component.html',
    styleUrls: ['./mini-donut-percentage.component.scss'],
    imports: [ChartMiniDonutComponent]
})
export class MiniDonutPercentageComponent implements OnChanges {
	@Input() data: IMiniDonutChart;
	@Input() diameter = 150;
	@Input() doNotShowChartPlaceholder? = true;
	public chartData: SingleSeriesChartViewDataItem[] = [];
	constructor(private chartColorProvider: ChartColorProvider,) { }

	ngOnChanges(changes: SimpleChanges): void {
		this.chartData.push({ percentage: Math.round(this.data.percentage) / 100, color: this.chartColorProvider.getColor(this.data.color) })
		this.chartData.push({ percentage: (Math.round(100 - this.data.percentage) / 100), color: this.chartColorProvider.getColor(DashboardColorTypes.filling) })
	}

	get percentageView() {
		if (isNullish(this.data.percentage)) { return '0%' }
		if (this.data.percentage > 0 && this.data.percentage < 1) {
			return '<1%'
		}
		return `${localeNumberFormat(Math.round(this.data.percentage))}%`
	}
}

export interface IMiniDonutChart {
	captionKey: string;
	// percentage muss als float oder double vom backend geliefert werden, damit bei werten zwischen 0 und 1 der Wert "<1%" angezeigt werden kann
	percentage: number;
	color: DashboardColorTypes
}
